// DocumentStartEndTime.js — Extracted from Document.js
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import "dayjs/locale/en";
import ReadOnlyDocumentField from "./ReadOnlyDocumentField";

const pickerSlotProps = {
  textField: {
    size: "small",
    error: false,
    sx: {
      '& .MuiInputBase-input': { fontSize: '0.8125rem', padding: '8px 12px' },
      '& .MuiInputLabel-root': { fontSize: '0.75rem' },
      '& .MuiOutlinedInput-root': { backgroundColor: 'var(--color-white)' },
    },
  },
};

const DocumentStartEndTime = ({
  datePickerValue,
  setDatePickerValue,
  startTimePickerValue,
  setStartTimePickerValue,
  endTimePickerValue,
  setEndTimePickerValue,
  handleDatePickerSave,
  handleTimePickerSave,
  isEditable = true,
}) => {
  if (!isEditable) {
    return (
      <div className="standard-container">
        <div className="datetime-header datetime-row">
          <ReadOnlyDocumentField label="Document Date" value={datePickerValue?.isValid() ? datePickerValue.format("MM/DD/YYYY") : null} />
          <div className="datetime-time-fields">
            <ReadOnlyDocumentField label="Start Time" value={startTimePickerValue?.isValid() ? startTimePickerValue.format("h:mm A") : null} />
            <ReadOnlyDocumentField label="End Time" value={endTimePickerValue?.isValid() ? endTimePickerValue.format("h:mm A") : null} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <div className="standard-container">
        <div className="datetime-header datetime-row">
          <div className="datetime-date-field">
            <DatePicker
              label="Document Date"
              value={datePickerValue}
              onChange={(newValue) => {
                setDatePickerValue(newValue);
                if (newValue && newValue.isValid()) {
                  handleDatePickerSave(newValue);
                }
              }}
              slotProps={pickerSlotProps}
            />
          </div>

          <div className="datetime-time-fields">
            <div className="datetime-time-field">
              <TimePicker
                label="Start Time"
                value={startTimePickerValue}
                onChange={(newValue) => {
                  setStartTimePickerValue(newValue);
                  if (newValue && newValue.isValid()) {
                    handleTimePickerSave("startTime", newValue);
                  }
                }}
                slotProps={pickerSlotProps}
              />
            </div>
            <div className="datetime-time-field">
              <TimePicker
                label="End Time"
                value={endTimePickerValue}
                onChange={(newValue) => {
                  setEndTimePickerValue(newValue);
                  if (newValue && newValue.isValid()) {
                    handleTimePickerSave("endTime", newValue);
                  }
                }}
                slotProps={pickerSlotProps}
              />
            </div>
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default DocumentStartEndTime;
